import { lpcoAbbreviation } from '../constants';
import { LicenseTypeNature } from '../types';

import useLicenseTypeNature from './useLicenseTypeNature';

function useLicenseAbbreviation() {
  const licenseTypeNature = useLicenseTypeNature();

  return licenseTypeNature === LicenseTypeNature.EPHYTO ? 'ePhyto' : lpcoAbbreviation;
}

export default useLicenseAbbreviation;
